<template>
  <div class="text">
      <h2>我是textzujian </h2>
  </div>
</template>

<script>
export default {
    name:'vue-text'

}
</script>

<style lang="scss" scoped>

</style>